import styled from "styled-components";

const Card = styled.div`
  flex: 1;
  margin: 0px 20px;
  padding: 30px;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
`;

const ValueContainer = styled.div`
  margin: 10px 0px;
  display: flex;
  align-items: center;
`;

const Title = styled.span`
  font-size: 20px;
`;

const Subtitle = styled.span`
  font-size: 14px;
  color: #555;
`;

const Value = styled.span`
  font-size: ${(props) => (props.big ? "50px" : "30px")};
  font-weight: 600;
  color: ${(props) => (props.color ? props.color : "black")};
`;

const FeaturedInfoCard = (props) => {
  return (
    <Card>
      <Title>{props.title}</Title>
      <ValueContainer>
        <Value big={props.big} color={props.color}>
          {props.value}
        </Value>
      </ValueContainer>
      <Subtitle>{props.subtitle}</Subtitle>
    </Card>
  );
};

export default FeaturedInfoCard;
